import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useEffect, useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { AVATAR_SIZES, AvatarContent } from '@atlaskit/avatar';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import TeamIcon from '@atlaskit/icon/glyph/people';
import { fg } from '@atlaskit/platform-feature-flags';
import { N0, N90 } from '@atlaskit/theme/colors';
import { FallbackAvatar } from './fallback';
import { TeamAvatarImage as TeamAvatarImageNext } from './teams-avatar-image-next';
var ICON_BACKGROUND = "var(--ds-icon-inverse, ".concat(N0, ")");
var ICON_COLOR = "var(--ds-icon-subtle, ".concat(N90, ")");
// used in a size calculation so can't be a token. Without this the avatar looks very squished
var ICON_PADDING = 4;
var avatarDefaultIconStyles = css({
  display: 'flex',
  backgroundColor: ICON_COLOR,
  borderRadius: '50%',
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center'
});
var SIZES = {
  xsmall: 16,
  small: 24,
  medium: 32,
  large: 40,
  xlarge: 96,
  xxlarge: 128
};
var nestedAvatarStyles = Object.entries(AVATAR_SIZES).reduce(function (styles, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    size = _ref2[1];
  return _objectSpread(_objectSpread({}, styles), {}, _defineProperty({}, key, css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat(size, "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: "".concat(size, "px"),
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& svg': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      width: "".concat(size - ICON_PADDING, "px"),
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      height: "".concat(size - ICON_PADDING, "px")
    }
  })));
}, {});
var avatarImageStyles = css({
  display: 'flex',
  flex: '1 1 100%',
  width: '100%',
  height: '100%'
});

/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */
export var TeamAvatarImageLegacy = function TeamAvatarImageLegacy(_ref3) {
  var _ref3$alt = _ref3.alt,
    alt = _ref3$alt === void 0 ? '' : _ref3$alt,
    src = _ref3.src,
    size = _ref3.size,
    testId = _ref3.testId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasImageErrored = _useState2[0],
    setHasImageErrored = _useState2[1];

  // If src changes, reset state
  useEffect(function () {
    setHasImageErrored(false);
  }, [src]);
  if (!src || hasImageErrored) {
    if (fg('enable-team-avatar-switch')) {
      return jsx(FallbackAvatar, {
        "aria-label": alt,
        width: SIZES[size],
        height: SIZES[size],
        "data-testid": testId
      });
    }
    return jsx("span", {
      css: [avatarDefaultIconStyles, nestedAvatarStyles[size]]
    }, jsx(PeopleGroupIcon, {
      label: alt,
      color: ICON_BACKGROUND,
      LEGACY_secondaryColor: ICON_COLOR,
      testId: testId && "".concat(testId, "--team"),
      spacing: "spacious",
      LEGACY_fallbackIcon: TeamIcon
    }));
  }
  return jsx(AvatarContent, null, jsx("img", {
    src: src,
    alt: alt,
    "data-testid": testId && "".concat(testId, "--image"),
    css: avatarImageStyles,
    onError: function onError() {
      return setHasImageErrored(true);
    }
  }));
};
export var TeamAvatarImage = function TeamAvatarImage(props) {
  if (fg('team-avatar-radii')) {
    return jsx(TeamAvatarImageNext, props);
  }
  return jsx(TeamAvatarImageLegacy, props);
};